<template>
    <el-dialog
        title="标签管理"
        :visible="true"
        width="300px"
        :close-on-click-modal="false"
        :before-close="dialogBeforeClose"
    >
        <el-table :data="tableData" :height="250" border>
            <el-table-column
                prop="tabName"
                label="标签名称"
                width="150px"
                show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column prop="prop" label="操作" width="110px">
                <template slot-scope="scope">
                    <el-button
                        @click="handleClick(scope.row)"
                        type="text"
                        size="small"
                        >应用</el-button
                    >
                    <el-button
                        @click="handleDelete(scope.row)"
                        type="text"
                        size="small"
                        >删除</el-button
                    >
                </template>
            </el-table-column>
        </el-table>
    </el-dialog>
</template>

<script>
import { queryTabList, tabRemove } from '@/modules/transport/otp/api/performanceDispatchMgmtNew.js';
export default {
    data () {
        return {
            tableData: []
        };
    },
    mounted () {
        this.getLabelData();
    },
    methods: {
        dialogBeforeClose () {
            this.$emit('update:isShowLabelManage', false);
        },
        /**
         * @description 获取标签列表
         */
        getLabelData () {
            queryTabList({ visualReportDefId: this.$route.path }).then(res => {
                if (res && +res.code === 0) {
                    this.tableData = res.data || [];
                }
            });
        },
        /**
         * @description 应用标签
         */
        handleClick (row) {
            this.$emit('handleInitData', row);
            this.dialogBeforeClose();
        },
        /**
         * @description 删除标签
         */
        handleDelete (row) {
            this.$confirm('此操作将删除该标签, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                tabRemove(row.id).then(res => {
                    if (res && +res.code === 0) {
                        this.$message.success('删除成功');
                        this.getLabelData();
                    }
                });
            }).catch(() => { });
        }
    }
};
</script>
